export default "__VITE_ASSET__2tY5Wj5k__"